import ApiERP from '@/core/conectores/ApiERP';
import { IListaPaginada } from '@/core/models/Consulta/IListaPaginada';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IFiltrosRelatorioVendas } from '@/models/Relatorios/Venda/IFiltrosRelatorioVendas';
import { IDadosRelatorioVendaCliente } from '@/models/Relatorios/Venda/IDadosRelatorioVendaCliente';
import { IDadosRelatorioVendaProduto } from '@/models/Relatorios/Venda/IDadosRelatorioVendaProduto';
import { IDadosRelatorioMargemLucro } from '@/models/Relatorios/Venda/IDadosRelatorioMargemLucro';
import { IDadosRelatorioAnaliseDesconto } from '@/models/Relatorios/Venda/IDadosRelatorioAnaliseDesconto';
import { IDadosRelatorioComissao } from '@/models/Relatorios/Venda/IDadosRelatorioComissao';
import { IFiltrosRelatorioComissao } from '@/models/Relatorios/Venda/IFiltrosRelatorioComissao';
import { IParametrosRelatorioVendas } from '@/models/ParametrosRequisicao/Vendas/IParametrosRelatorioVendas';
import { IDTORelatorioVenda } from '@/models/Relatorios/Venda/IDTORelatorioVenda';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IDadosRelatorio } from '@/models/Entidades/Relatorios/DadosRelatorio';
import { IItemConsultaRapida } from '@/core/models/Consulta/IItemConsultaRapida';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';

/**
 * Serviço de Relatórios de Vendas.
 */

class ServicoRelatoriosVendas {
    endPoint = 'relatorios-vendas';

    apiERP = new ApiERP();

    public requisicaoSistema():void{
      this.apiERP = new ApiERP(true);
    }

    public async obterArquivoVendaCliente(tipoArquivo: ETipoArquivo, filtros: IFiltrosRelatorioVendas):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/vendas-por-cliente/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterVendaCliente(filtros: IFiltrosRelatorioVendas): Promise<IDadosRelatorioVendaCliente> {
      const result: any = await this.apiERP.post(`${this.endPoint}/vendas-por-cliente`, filtros);
      const listaPaginada = {} as IListaPaginada;
      listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
      listaPaginada.dados = result.data.itens;
      result.data.itens = listaPaginada;
      return result.data;
    }

    public async obterVendaProduto(filtros: IFiltrosRelatorioVendas): Promise<IDadosRelatorioVendaProduto> {
      const result: any = await this.apiERP.post(`${this.endPoint}/vendas-por-produtos/`, filtros);
      const listaPaginada = {} as IListaPaginada;
      listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
      listaPaginada.dados = result.data.itens;
      result.data.itens = listaPaginada;
      return result.data;
    }

    public async obterArquivoVendaProduto(tipoArquivo: ETipoArquivo, filtros: IFiltrosRelatorioVendas):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/vendas-por-produtos/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterMargemLucro(filtros: IFiltrosRelatorioVendas): Promise<IDadosRelatorioMargemLucro> {
      const result: any = await this.apiERP.post(`${this.endPoint}/margem-de-lucro`, filtros);
      const listaPaginada = {} as IListaPaginada;
      listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
      listaPaginada.dados = result.data.itens;
      result.data.itens = listaPaginada;
      return result.data;
    }

    public async obterArquivoMargemLucro(tipoArquivo: ETipoArquivo, filtros: IFiltrosRelatorioVendas):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/margem-de-lucro/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterAnaliseDesconto(filtros: IFiltrosRelatorioVendas): Promise<IDadosRelatorioAnaliseDesconto> {
      const result: any = await this.apiERP.post(`${this.endPoint}/analise-desconto`, filtros);
      const listaPaginada = {} as IListaPaginada;
      listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
      listaPaginada.dados = result.data.itens;
      result.data.itens = listaPaginada;
      return result.data;
    }

    public async obterArquivoAnaliseDesconto(tipoArquivo: ETipoArquivo, filtros: IFiltrosRelatorioVendas):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/analise-desconto/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterComissao(filtros: IFiltrosRelatorioComissao): Promise<IDadosRelatorioComissao> {
      const result: any = await this.apiERP.post(`${this.endPoint}/comissao`, filtros);
      const listaPaginada = {} as IListaPaginada;
      listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
      listaPaginada.dados = result.data.itens;
      result.data.itens = listaPaginada;
      return result.data;
    }

    public async obterArquivoComissao(tipoArquivo: ETipoArquivo, filtros: IFiltrosRelatorioComissao):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/comissao/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterRelatorioVendas(parametros: IParametrosRelatorioVendas): Promise<IDTORelatorioVenda> {
      const result: any = await this.apiERP.post(`${this.endPoint}/painel-vendas`, parametros);
      return result.data;
    }

    public async obterArquivRelatoriooVenda(tipoArquivo: ETipoArquivo, parametros: IParametrosRelatorioVendas):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/painel-vendas/arquivo/${tipoArquivo}`, parametros);
      return result.data;
    }

    public async salvarFiltrosRelatorioVenda(parametros: IParametrosRelatorioVendas): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.post(`${this.endPoint}/painel-vendas/salvar-filtros`, parametros);
      return result.data;
    }

    public async obterFiltrosSalvosRelatorioVenda(): Promise<IDadosRelatorio[]> {
      const result: any = await this.apiERP.get(`${this.endPoint}/painel-vendas/obter-filtros-salvos`);
      return result.data;
    }

    public async consultaRapida(parametrosConsultaRapida: IParametrosConsultaRapida): Promise<IItemConsultaRapida[]> {
      const parametrosAdicionais = this.apiERP.obterParametrosAdicionaisConsultaRapida(parametrosConsultaRapida);
      const result: any = await this.apiERP.get(`${this.endPoint}/consulta-rapida${parametrosAdicionais}`);
      return result.data;
    }
}
export default ServicoRelatoriosVendas;
